import ClubRoleRight from './ClubRoleRight';

export default class ClubRole {

    static ADMIN = 'admin';
    static SUBADMIN = 'subadmin';

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubRole = new ClubRole();
        clubRole.id = data.id;
        clubRole.name = data.name;
        clubRole.custom = data.custom;
        if (data.roleRights) {
            clubRole.roleRights = data.roleRights.data.map(roleRight => ClubRoleRight.fromData(roleRight));
        }

        return clubRole;
    }
}
